import { fetchAuthSession } from 'aws-amplify/auth';

const awsconfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || '',
      userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID || '',
      loginWith: {
        oauth: {
          domain: process.env.REACT_APP_COGNITO_DOMAIN || '',
          scopes: ['email', 'openid', 'profile'],
          redirectSignIn: [process.env.REACT_APP_REDIRECT_URI || 'http://localhost:3000'],
          redirectSignOut: [process.env.REACT_APP_REDIRECT_URI || 'http://localhost:3000'],
          responseType: 'code' as const
        }
      }
    }
  },
  API: {
    REST: {
      PhotosynthesizeAPI: {
        endpoint: process.env.REACT_APP_API_GATEWAY_URL || '',
        region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
        custom_header: async () => {
          try {
            // fetchAuthSession automatically refreshes expired tokens
            const session = await fetchAuthSession();
            const token = session.tokens?.idToken?.toString();

            if (!token) {
              console.error('[AUTH] No token available, redirecting to login');
              if (window.location.pathname !== '/') {
                window.location.href = '/';
              }
              throw new Error('No authentication token available');
            }

            return {
              Authorization: `Bearer ${token}`
            };
          } catch (e) {
            console.error('[AUTH] Failed to get auth session:', e);
            // If token refresh fails, redirect to login
            if (window.location.pathname !== '/') {
              window.location.href = '/';
            }
            throw e;
          }
        }
      }
    }
  }
};

export default awsconfig;
